var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1615_96386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1615_96386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1615_96386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1615_96386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1615_96386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 19.1648C10.6077 19.1646 11.1904 18.923 11.62 18.4933C12.0496 18.0635 12.2909 17.4808 12.2909 16.8731H7.7076C7.7076 17.1741 7.76691 17.4722 7.88212 17.7503C7.99734 18.0284 8.16622 18.2811 8.37911 18.4939C8.592 18.7067 8.84473 18.8755 9.12286 18.9906C9.401 19.1057 9.69909 19.1649 10.0001 19.1648ZM17.7126 13.804C17.0209 13.0606 15.7268 11.9423 15.7268 8.27896C15.7278 6.96486 15.2711 5.69144 14.4351 4.67754C13.5992 3.66364 12.4361 2.97258 11.1459 2.72313V1.97312C11.1459 1.82276 11.1163 1.67387 11.0588 1.53495C11.0012 1.39603 10.9169 1.26981 10.8106 1.16349C10.7043 1.05716 10.578 0.972825 10.4391 0.915283C10.3002 0.857741 10.1513 0.828125 10.0009 0.828125C9.85057 0.828125 9.70168 0.857741 9.56276 0.915283C9.42385 0.972825 9.29762 1.05716 9.1913 1.16349C9.08498 1.26981 9.00064 1.39603 8.94309 1.53495C8.88555 1.67387 8.85594 1.82276 8.85594 1.97312V2.72313C7.56528 2.97207 6.40167 3.66291 5.56521 4.67686C4.72874 5.69081 4.27167 6.96451 4.2726 8.27896C4.2726 11.9456 2.97844 13.0606 2.28677 13.804C2.08768 14.0137 1.97748 14.2923 1.97927 14.5815C1.97938 14.7322 2.0092 14.8814 2.06703 15.0206C2.12486 15.1598 2.20957 15.2862 2.3163 15.3926C2.42303 15.499 2.5497 15.5834 2.68905 15.6408C2.8284 15.6982 2.97771 15.7276 3.12844 15.7273H16.8718C17.0225 15.7276 17.1718 15.6982 17.3112 15.6408C17.4505 15.5834 17.5772 15.499 17.6839 15.3926C17.7906 15.2862 17.8753 15.1598 17.9332 15.0206C17.991 14.8814 18.0208 14.7322 18.0209 14.5815C18.0226 14.2922 17.9121 14.0135 17.7126 13.804Z",
    fill: "#9196AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_96386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileNotification);
export default __webpack_public_path__ + "static/media/icon-profile-notification.4c72e0531c308e0058fa705ac1191b46.svg";
export { ForwardRef as ReactComponent };